/*
 *
 *   reducer
 *
 */
import produce from "immer"
//import key from './key'

import {
    LOAD_RECORDS_META_DATA_SUCCESS,
    LOAD_RECORDS_META_DATA_ERROR,
     CHANGE_PASSWORD_ERROR,
     CHANGE_PASSWORD_SUCCESS
    } from "./constants"


const initialState = {
  
    passwordData:[],
    changeData:{},
    loading: false,
    error: false,
    success: false,
}

export default function Reducer(
    state = initialState,
    {   changeData={},
        type,
        passwordData=[],
        error,
        success,
    }
) {
    return produce(state, (draft) => {
        switch (type) {
            case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.passwordData =passwordData
        draft.error = false
        draft.success = success
        break
        case CHANGE_PASSWORD_SUCCESS:
            draft.changeData = changeData
            draft.error = false
            draft.success = success
            break
            case  CHANGE_PASSWORD_ERROR:
            case LOAD_RECORDS_META_DATA_ERROR:
                draft.loading = false
                draft.error = error
                draft.success = false
                break
        }
    })
}